import $ from 'jquery';
import { result } from 'underscore';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { QueryParam } from '@bingads-webui-react/scope-service';
import { InsightType, Metrics, formatInsightDetails } from '@bingads-webui-campaign-react/query-insights-common';
import { SummaryBarMetricsPicker } from '@bingads-webui-campaign-react/query-insights-summary-bar-metrics-picker';
import { siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { SummaryBarFactory } from './components';
import { getSummaryBarStyle } from './styles';

const QueryInsightsSummaryBarUnstyled = ({
  i18n,
  scope,
  siteMap,
  summaryBarActivityLogger,
  backButtonUrl,
}) => {
  const [summaryDetails, setSummaryDetails] = useState(null);

  const formattedSummary = useMemo(() => formatInsightDetails(i18n, summaryDetails), [i18n, summaryDetails]);

  const summaryBarProps = useMemo(() => ({
    i18n,
    scope,
    siteMap,
    summaryBarActivityLogger,
    backButtonProps: {
      buttonText: i18n.getString(_TL_('Back')),
      url: backButtonUrl,
    },
    breadcrumbsGeneralConfigs: {
      maxDisplayedItems: 3,
      items: [{
        key: 'query-insights',
        text: i18n.getString(_TL_('Search insights')),
        isLongText: true,
        'aria-label': i18n.getString(_TL_('Search insights')),
        onClick: () => {
          scope.remove(['trendPeriod', 'country', 'vertical']);
          scope.save(scope.location.pathname.replace(/\/details$/, ''));
        },
      }, ...formattedSummary ? [{
        key: 'query-insights-details',
        text: formattedSummary,
        isCurrentItem: true,
        isLongText: true,
        'aria-label': formattedSummary,
      }] : []],
    },
    summaryBarItems: result(summaryDetails, 'InsightType') === InsightType.AccountOptimization ? [{
      className: 'summary-bar-metrics',
      canEdit: true,
      noOverflow: true,
      renderEntityItem: () => (
        <SummaryBarMetricsPicker
          i18n={i18n}
          metrics={Metrics}
        />
      ),
    }] : [],
  }), [backButtonUrl, formattedSummary, i18n, scope, siteMap, summaryBarActivityLogger, summaryDetails]);

  const onDetailsUpdated = useCallback((e, details) => {
    setSummaryDetails(details);
  }, []);

  useEffect(() => {
    $(document).on('qiDetailsUpdated', onDetailsUpdated);

    return () => {
      $(document).off('qiDetailsUpdated', onDetailsUpdated);
    };
  }, [onDetailsUpdated]);

  return (<SummaryBarFactory {...summaryBarProps} />);
};

QueryInsightsSummaryBarUnstyled.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  siteMap: siteMapPropType.isRequired,
  summaryBarActivityLogger: PropTypes.shape({
    changeScopeActivity: PropTypes.any,
  }).isRequired,
  backButtonUrl: PropTypes.string.isRequired,
};

export const QueryInsightsSummaryBar = withDefaultStyles(QueryInsightsSummaryBarUnstyled, getSummaryBarStyle);
